var _rect, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgMoneySmall = function SvgMoneySmall(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.107,
    height: 11.107,
    x: 10.5,
    y: 3.351,
    stroke: "#F4F4F4",
    rx: 1.5,
    transform: "rotate(45 10.5 3.35)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7.892,
    r: 1.535,
    stroke: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    strokeLinecap: "round",
    d: "M10.5 7.893a3.445 3.445 0 1 0-3.445-3.445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M10.5 11a.5.5 0 0 1 .149.023.4.4 0 0 1 .126.067.3.3 0 0 1 .085.101q.03.059.03.121.003.126.002.248c.614.07 1.113.543 1.106 1.051v.171a.3.3 0 0 1-.114.216.43.43 0 0 1-.265.092.44.44 0 0 1-.268-.082.3.3 0 0 1-.127-.211c-.006-.066-.002-.129-.005-.193a.4.4 0 0 0-.158-.295.6.6 0 0 0-.17-.092v1.06c.373.122.729.272.915.538.497.611-.022 1.539-.913 1.625 0 .066.002.185 0 .25a.3.3 0 0 1-.121.223.44.44 0 0 1-.277.087.44.44 0 0 1-.27-.093.3.3 0 0 1-.113-.22 6 6 0 0 1-.002-.232v-.015a1.4 1.4 0 0 1-.803-.377.97.97 0 0 1-.303-.717c-.029-.217.083-.428.38-.436.099-.003.196.026.27.081a.3.3 0 0 1 .125.213c.005.067.002.133.005.197a.4.4 0 0 0 .052.167.5.5 0 0 0 .126.138.6.6 0 0 0 .148.077v-1.068l-.218-.07c-1.29-.382-1.12-1.902.218-2.085 0-.084-.002-.165.002-.25a.3.3 0 0 1 .117-.22.44.44 0 0 1 .271-.09m.393 3.783c.405-.126.45-.655.014-.803l-.015-.005zm-.783-2.562a.43.43 0 0 0-.32.335c-.034.204.086.386.305.462l.015.005z"
  })));
};
export default SvgMoneySmall;